import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { rootRoute } from './root.tsx'

// Guard in `beforeLoad`, component lazy: why both, in
// apps/frontend/docs/razionale-che-il-codice-indica.md.
export const clubsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.clubs,
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club', 'coach'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/clubs.tsx')),
})
